<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="mx-3"
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-format-vertical-align-top
        </v-icon>
        Upload
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      :title="'Employee Statutory Informations'"
      :text="'Employee Statutory Informations Import'"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <helper-file-input
                v-model="file" 
                v-validate="'required'"
                :max-size-in-mb="10"
                :max-number="1"
                :multiple="true"
                data-vv-name="file"
                field-name="file"
                accept-type=".xlsx"    
                extension="ext:xlsx"      
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mr-2"    
                  >
                    Add file
                  </v-btn>
                  <span> 
                    {{ file ? '' : 'No file chosen (.xlsx only)' }}
                  </span>
                </div>
              </helper-file-input>
              <div
                v-if="file"
                class="mt-2"
              >
                <div
                  v-for="selectedFile in file.selectedFiles"
                  :key="selectedFile.name"
                  class="d-flex align-center"
                >
                  <v-icon
                    color="hrissuccess"
                    class="mr-2"
                  >
                    mdi-file-excel
                  </v-icon>
                  <span class="font-weight-bold text-truncate">{{ selectedFile.name }}</span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :disabled="progressing"
                        icon
                        small
                        class="ml-2"
                        v-on="on"
                        @click="removeFile"
                      >
                        <v-icon
                          small
                          color="error"
                        >
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Remove file</span>
                  </v-tooltip>
                </div>
              </div>
              <span class="red--text text--lighten-1">{{ errors.first('file') }}</span>
            </v-col>
          </v-row>

          <v-row v-if="errorImporting">
            <v-col cols="12">
              <span style="color:red;font-size:15px;font-weight:900">Error</span> 
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              :class="{
                'overflow': failed.length>0,
              }"
              data-simplebar
            >
              <div
                v-for="(item,i) in failed"
                :key="i"
              >
                <span style="color:red">
                  {{ item }}
                </span>
              </div>
            </v-col>
          </v-row>
        </v-container> 
      </form>
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      HelperFileInput: () => import('@/components/hris/helper/FileInput'),
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        file: null,
        errorImporting: false, 
        failed: [],
      }
    },
 
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        this.loading = true
        this.loading = false
      },
    },
    methods: { 
      prepareFormData () {
        return this.file.formData
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)

            this.errorImporting = false
            this.$api.payrollImports().employeeContributionImport(this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              }).catch(e => {
                if (e.response.status === 409 || e.response.status === 422) {
                  this.errorImporting = true

                  this.failed = [e.response.data.message]
                } 
                this.setProgressing(false)
              })
          })
      },
      removeFile () {
        this.file = null
        this.errorImporting = false
        this.failed = []
      },
      setProgressing (status) {
        this.progressing = status
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px
}
</style>
